import { GetCompanyContactType as ApiCompanyContactType } from 'src/api/generated/touring/types';
import { CompanyContactType } from '../../types';

export const mapCompanyContactType = (
  apiType: ApiCompanyContactType
): CompanyContactType => {
  return {
    personId: apiType.personId,
    personName: apiType.personName,
    companyId: apiType.companyId,
    companyName: apiType.companyName,
  };
};
